import {SET_OPEN_BATTERY} from "../actionTypes/open";
import {openBatteryIdSelector} from "../reducers/openReducer";
import {clearHistory} from "./history";

export const setOpenBattery = batteryId => {
    return async (dispatch, getState) => {
        console.log('ceci est un log de batterie id' + batteryId)
        if(openBatteryIdSelector(getState()) !== batteryId) {await dispatch(clearHistory())}
        dispatch({
            type: SET_OPEN_BATTERY,
            payload: batteryId,
        })
    }
}